import { useTranslation } from 'react-i18next';
import { MdPriorityHigh } from 'react-icons/md';
import HeroCard from '../HeroCard';

const ConsentSessionExpired = () => {
  const [t] = useTranslation('calendar');

  return (
    <HeroCard
      variant="danger"
      icon={<MdPriorityHigh />}
      title={t('select-context.expired-title')}
    >
      {t('select-context.expired-description')}
    </HeroCard>
  );
};

export default ConsentSessionExpired;
